{ "imageTag": "20261105023001_3a43c49", "buildUri": "vstfs:///Build/Build/104201", "buildId": "104201", "sourceCommit": "3a43c4983bf8caa49bb645b848a5c92030cf4870", "sourceBranch": "main", "releaseDate": "2026-11-05T02:33:01Z" }
